const TrustPilot = process.env.PUBLIC_URL + '/images/TrustPilot.svg'

const TrustpilotRating = (props: any) => {
  return <img src={TrustPilot} alt="TrustPilot" style={{ height: '84px' }} />
}

export default TrustpilotRating;
